import Repository from "../Repository";

const resource = "/sites";
export default {

    getAll(nolayout = false) {
        return Repository.get(`${resource}?nolayout=${nolayout}`);
    }

}